import {DateTime} from "luxon";
import {UuidHelper} from "../helpers/uuid.helper";
import {CommandName} from "./command-name.enum";
import {ICommand} from "./i-command.interface";

export abstract class AbstractCommand<T extends any> implements ICommand<T> {

    public uid: string = UuidHelper.generateV7();

    public dateTime: DateTime = DateTime.now();

    public abstract name: CommandName;

    public abstract tags: string[];

    public constructor(
        public readonly mainEntityClass: string,
        public readonly mainEntityUid: string,
        public readonly payload: T
    ) {
    }
}